/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import { useIntl } from 'react-intl'
import {useLayout} from '../core'
import { version } from '../../../../package.json';
import { Link } from 'react-router-dom';

const Footer: FC = () => {
  const {classes} = useLayout()
  const intl = useIntl()
  return (
    <div className='footer py-4 d-flex flex-lg-column' id='kt_footer'>
      {/* begin::Container */}
      <div
        className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        {/* begin::Copyright */}
        <div className='text-dark order-2 order-md-1'>
          <span className='text-muted fw-bold me-2'>{new Date().getFullYear()} &copy;</span>
          <a href='#' className='text-gray-800 text-hover-primary'>
            {intl.formatMessage({id: "FOOTER.COPYTIGHT"})}
          </a>
          <Link to={'/release-notes'} className='text-gray-800 text-hover-primary ms-2'>
            v{version}
          </Link>
        </div>
        {/* end::Copyright */}

        {/* begin::Nav */}
        <ul className='menu menu-gray-600 menu-hover-primary fw-bold order-1'>
          <li className='menu-item'>
            <a href='https://treeplantingprojects.com/ueber-uns/' target={'_blank'} rel="noreferrer" className='menu-link ps-0 pe-2'>
            {intl.formatMessage({id: 'FOOTER.ABOUT'})}
            </a>
          </li>
          <li className='menu-item'>
            <a href='https://treeplantingprojects.com/ueber-uns/#kontakt' target={'_blank'} rel="noreferrer" className='menu-link pe-0 pe-2'>
            {intl.formatMessage({id: 'FOOTER.CONTACT'})}
            </a>
          </li>
          <li className='menu-item'>
            <a href='https://treeplantingprojects.com/impressum/' target={'_blank'} rel="noreferrer" className='menu-link pe-0'>
            {intl.formatMessage({id: 'FOOTER.IMPRINT'})}
            </a>
          </li>
        </ul>
        {/* end::Nav */}
      </div>
      {/* end::Container */}
    </div>
  )
}

export {Footer}
